export const selectBirthAdoption = state => state.birthAdoption;